<template>
  <div class="user_container">
    <div class="user_a">
      <div class="user_tabs" style="float: bottom" v-if="this.activeName != 'prescription'">
        <el-card type="border-card">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            tab-position="left"
          >
            <el-tab-pane
              class="tab_item"
              label="基本资料"
              name="userInfo"
              :userData="userData"
            >
              <!-- <VInformation /> -->
            </el-tab-pane>
            <el-tab-pane
              class="tab_item"
              label="服务信息"
              name="serveInfo"
              :userData="userData"
            >
              <!-- <VQualifications /> -->
            </el-tab-pane>
            <!-- <el-tab-pane label="我的资质" name="qualifications" :userData="userData">
            </el-tab-pane>
            <el-tab-pane label="实名认证" name="authentication" :userData="userData">
            </el-tab-pane> -->
            <el-tab-pane label="我的消息" name="news">
              <!-- <VNews /> -->
            </el-tab-pane>
            <!-- <el-tab-pane class="tab_item" label="我的钱包" name="wallet">
            </el-tab-pane> -->
            <!-- <el-tab-pane class="tab_item" label="我的考勤" name="attendance"> -->
            <!-- <Setup /> -->
            <!-- </el-tab-pane> -->
            <el-tab-pane class="tab_item" label="问诊订单" name="patients">
            </el-tab-pane>
            <!-- <el-tab-pane class="tab_item" label="补单" name="replenishment">
            </el-tab-pane> -->
            <!-- <el-tab-pane class="tab_item" label="远程会诊" name="remoteInterrogation">
            </el-tab-pane>-->
            <!-- <el-tab-pane class="tab_item" label="转诊管理" name="transfer">
            </el-tab-pane>-->
            <!-- <el-tab-pane
              class="tab_item"
              label="我的预约"
              name="appointmentList"
            >
            </el-tab-pane> -->
            <!-- 乐荐隐藏退费 -->
            <!-- <el-tab-pane class="tab_item" label="退费列表" name="moneyBack">
            </el-tab-pane> -->
            <!-- <el-tab-pane class="tab_item" label="报告管理" name="reportManage"> -->
            <!-- <Setup /> -->
            <!-- </el-tab-pane> -->
            <!-- <el-tab-pane
              class="tab_item"
              label="上报管理"
              name="adverseReaction"
            > -->
            <!-- <Setup /> -->
            <!-- </el-tab-pane> -->
            <!-- <el-tab-pane class="tab_item" label="处方管理" name="prescription">
            </el-tab-pane> -->
            <el-tab-pane class="tab_item" label="设置管理" name="setup">
              <!-- <Setup /> -->
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
      <div class="user_content" style="float: bottom">
        <router-view />
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="user_b">
      <Vfooter />
    </div>
  </div>
</template>

<script>
import Vfooter from "@/components/footer/index.vue";
import utils from "@/utils";
import { getDoctorInformation } from "@/api";
export default {
  data() {
    return {
      activeName: "userInfo",
      isLoading: false,
      userData: {},
      // tabPosition: left,
      name: "",
      status: "",
      userInfo: {},
    };
    `-`;
  },

  components: {
    Vfooter,
  },
  created() {
    this.getUrl();
    this.getUserInfo();
  },
  watch: {
    // 更新页面所在位置，用于判断是前进页还是后退页
    $route(to, from) {
      var cur = to.path.split("/");
      this.activeName = cur[3];
    },
  },
  computed: {},
  methods: {
    /**
     * @desc 个人信息回显
     */
    async getUserInfo() {
      try {
        const params = {};
        let { code, data } = await getDoctorInformation(params);
        if (code === 1) {
          this.status = data.status;
          this.userInfo = data;
          this.$store.commit("setProfileStep", data.profileStep);
          this.$store.commit("setStatus", data.status);
          this.handleClick();
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClick(tab, event) {
      var urlName = "";
      // switch (this.activeName) {
      //   case "appointmentList":
      //     urlName = "/index/user/appointmentList?tabNum=3";
      //     break;
      //   case "auditInformation":
      //     if (this.status === 0) {
      //       //待审核
      //       urlName = "/index/user/auditInformation/auditInfo";
      //       if (this.userInfo.profileStep === 1 || this.userInfo.profileStep === 2 || this.userInfo.profileStep === 3){
      //           urlName = "/index/user/auditInformation/information";
      //       }
      //     }else if(this.status === 1){
      //       //审核通过
      //       urlName = "/index/user/auditInformation/information";
      //     }else if(this.status === -1) {
      //       //审核拒绝
      //       urlName = "/index/user/auditInformation/auditInfo";
      //     }
      //     break;
      //   default:
      //     urlName = "/index/user/" + this.activeName;
      //     break;
      // }
      // this.$router.push({
      //   path: urlName,
      // });
      if (this.activeName == "userInfo") {
        this.$router.push({
          path: "/index/user/userInfo",
        });
      } else {
        this.$router.push({
          path: "/index/user/" + this.activeName,
        });
      }
    },
    /**
     * 用于解决刷新页面后，二级标题高亮与当前页面指向不同问题
     */
    getUrl() {
      let currentUrl = window.location.href;
      this.activeName = currentUrl.split("#")[1].split("/")[3];
      console.log("this.activeName", this.activeName);
      if (this.$route.fullPath.split("/")[3] == "appointmentList?tabNum=3") {
        this.activeName = "appointmentList";
      }else if(this.activeName == "userinfo"){
        this.activeName = 'userInfo';
      }else if(this.activeName == "prescription"){
        this.activeName = 'prescription';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user_tabs .el-card {
  border: none;
  box-shadow: none;
}
// .user_hd {
//   width: 100px;
//   height: 0px;
// }
/*/deep/ .el-tabs--left .el-tabs__header.is-left {*/
/*  margin-right: 0;*/
/*}*/
.user_container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f5f6fa;
  min-width: 1300px;
}
.user_a {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  width: 100%;
  height: 100%;
  min-height: 600px;
}
.user_b {
  display: flex;
  width: 100%;
}
.user_tabs {
  display: flex;
  flex: 2;
  width: 280px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin-right: 0;
  padding-right: 0;
}
.user_content {
  min-height: 900px;
  position: relative;
  margin: 19px 18px 28px 18px;
  // display: flex;
  flex: 12;
  // max-width: 90%;
  // min-height: 700px;
  background: #ffffff;
  border-radius: 10px;
  // justify-content: center;
  /*.el-tabs--left .el-tabs__item.is-left {*/
  /*  text-align: center;*/
  /*}*/
}
/deep/ .el-tabs__nav-scroll {
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/*/deep/ .el-card__body {*/
/*  padding: 0px 0px 20px 20px;*/
/*}*/

/deep/ .el-tabs__item {
  flex: 1;
  text-align: center !important;
  font-size: 18px;
  line-height: 72px;
  display: inline-block;
  /*letter-spacing: 3px !important;*/
  width: 241px !important;
  height: 60px !important;
  border-radius: 30px 0px 0px 30px;
}

/deep/ .el-card-user-tab {
  // margin: 20px;
  min-height: 800px !important;
  border: none !important;
  box-shadow: none !important;
  // background: #f5f6fa;
  // max-width: 2px !important;
  // height: 800px;
}

/deep/ .tab_item {
  margin-top: 20px;
}

/deep/ .el-tabs__item.is-active {
  color: #fc701a;
  background: #f5f6fa;
  font-weight: bold;
  border: none !important;
  text-align: center;
}

/deep/ .el-tabs__active-bar {
  background-color: #fc701a;
  height: 0 !important;
}

/deep/ .el-tabs__item:hover {
  color: #fc701a;
}

/deep/ .el-tabs__item {
  // position: relative;
  // margin-top: 8%;
  /*padding: 0 80px 0 100px !important;*/
  // border-radius: 30px 0px 0px 30px;
  height: 70px !important;
  text-align: center;
  // border-right-style: 10px solid #f5f6fa;
}

/deep/ .el-tabs__active-bar {
  background: transparent;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
}

/deep/ .user-tabs {
  background: #ffffff !important;
  padding: 25% 10% 800px 35px;
  margin: 0 -90% 0 -20px;
  width: 210% !important;
}

/deep/ .el-tabs__nav {
  /*height: 1000px;*/
}

/deep/ .detail .el-tabs__nav {
  height: 0 !important;
}
</style>
